<template>
  <carousel :per-page="1"
            :per-page-custom="[[800, 1], [1000, 3], [1100, 4], [1400, 6]]"
            :navigation-enabled="myWindow.innerWidth > 500"
            :pagination-enabled="false"
            :center-mode="true"
            :loop="true"
            :navigation-next-label="`<img src='/img/landing/slide-right.png'/>`"
            :navigation-prev-label="`<img src='/img/landing/slide-left.png'/>`">
    <slide v-for="(institution, key) in institutions" :key="key" class="text-center">
      <a :href="institution.site" target="_blank" v-if="institution.logo" :style="{width: '140px', height: '90px', display: 'inline-block', backgroundImage: 'url(' + institution.logo.contentPath + ')', backgroundSize: 'contain', backgroundPosition: 'center center', backgroundRepeat: 'no-repeat' }"></a>
    </slide>
  </carousel>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';
export default {
  name: "PartnerList",
  props: ['institutions', 'myWindow'],
  components: {Carousel, Slide}
}
</script>

<style lang="scss" scoped>
@import "src/assets/scss/home";
</style>